import { render, staticRenderFns } from "./smoothResizer.vue?vue&type=template&id=4e0339ae&"
import script from "./smoothResizer.vue?vue&type=script&lang=ts&"
export * from "./smoothResizer.vue?vue&type=script&lang=ts&"
import style0 from "./smoothResizer.vue?vue&type=style&index=0&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports